import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import { useUser } from '../contexts/UserContext'
import { useConfig } from '../contexts/ConfigContext'
import { useCompany } from '../contexts/CompanyContext'
import { Layout } from 'antd'
import TopBar from './TopBar'
import useAuth from '../hooks/useAuth'
import ContentLayuout from './ContentLayout'

function Index(){
  const { config,updateConfig } = useConfig()
  const { updateCompanies } = useCompany()
  const { updateUser } = useUser()
  const [mobileView, setMobileView] = useState(window.innerWidth < 768);

  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:indexData} = useAuth.useIndex(tokenData,config.session)

  useEffect(()=>{
    console.log(indexData)
    if(indexData?.companies){
      if(indexData.companies.length === 1 && indexData.modules.length === 1){
        const redirect = indexData.modules[0].path + '/?session=' + tokenData.session
        console.log("Redireccion a: ",redirect)
        globalThis.location.href = redirect
        return
      }
      updateConfig({showProgress:false,session:tokenData.session})
      updateUser(indexData.user)
      const companies = indexData.companies.map((e:any)=>{
        return{
          ...e,
          modules: indexData.modules.filter((m:any)=>m.company_id === e.id)
        }
      })
      updateCompanies({list:companies,current:companies[0]})
    }
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setMobileView(isMobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  },[indexData,tokenData])

  return (
    <Layout style={{ minHeight: "100vh" }}>

      {/* Contenedor Principal */}
      <Layout style={{ transition: "0.3s" }}>
        {/* Header */}
        <TopBar mobileView={mobileView}></TopBar>
        {/* Contenido */}
        <ContentLayuout />
        {/* Footer */}
        <Footer />
      </Layout>
    </Layout>
  );
}


export default Index;